import React from "react";
import "./AdminHome.css";

const SECTIONS = [
  {
    title: "Orders",
    items: [
      { name: "Upload CSV",     desc: "Bulk add or update orders from a CSV file." },
      { name: "Enter Manually", desc: "Add individual orders or urgent entries." },
      { name: "View Orders",    desc: "Search and inspect current orders by clinic." },
    ],
  },
  {
    title: "History",
    items: [
      { name: "Recents",  desc: "Review the most recent CSV uploads." },
      { name: "Download", desc: "Export order batches for audit or clinic reporting." },
    ],
  },
  {
    title: "Admin",
    items: [
      { name: "Edit",          desc: "Modify existing order details." },
      { name: "Delete Orders", desc: "Remove individual orders or entire batches." },
    ],
  },
];

export default function AdminHome() {
  return (
    <div className="adminhome-container">
      <div className="adminhome-card">
        <h1 className="adminhome-title">Argencis Admin</h1>

        <div className="adminhome-grid">
          {SECTIONS.map((section) => (
            <div key={section.title} className="adminhome-column">
              <h2 className="adminhome-column-title">{section.title}</h2>
              {section.items.map((item) => (
                <div key={item.name} className="adminhome-item">
                  <div className="adminhome-item-name">{item.name}</div>
                  <div className="adminhome-item-desc">{item.desc}</div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
